import React from 'react';
import { Link } from 'react-router-dom';

function ThankYou() {
  return (
    <div className="relative bg-black text-white py-12 px-4 overflow-auto min-h-screen flex items-center justify-center">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-7xl font-light tracking-wider mb-8 bg-gradient-to-r from-white via-gray-200 to-gray-400 inline-block text-transparent bg-clip-text">
          Thank You
        </h1>
        <p className="text-2xl text-gray-300 max-w-3xl mx-auto font-light tracking-wider leading-relaxed mb-12">
          We've received your message and will be in touch soon.
        </p>
        <Link
          to="/"
          className="px-8 py-3 bg-white text-black font-medium rounded-xl 
            transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg hover:bg-gray-100"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}

export default ThankYou; 